import React, { View } from "react-native";
import {
    Button,
    InputControl,
    ModalWrapper,
    StyleData,
    StyleFunction,
    TextInput,
    useThemedStyle,
} from "@venuepos/react-common";
import { useTranslation } from "react-i18next";
import { useState } from "react";

export function EconomicVoucherTextModal({
    onClose,
}: {
    onClose: ({
        voucherText,
        sync,
    }: {
        voucherText?: string;
        sync: boolean;
    }) => void;
}) {
    const [t] = useTranslation();
    const styles = useThemedStyle(styleFunc);
    const [voucherText, setVoucherText] = useState<string>("");

    return (
        <ModalWrapper
            onClose={() => onClose({ sync: false })}
            title={t("shift.voucher_text_modal.headline", "Enter text")}
        >
            <View style={styles.container}>
                <InputControl
                    description={`${t(
                        "shift.voucher_text_modal.description",
                        "This text will be added to the vouchers when sync'ing. Max. 50 characters."
                    )}`}
                >
                    <TextInput
                        label={t(
                            "shift.voucher_text_modal.label",
                            "Text for vouchers"
                        )}
                        value={voucherText}
                        maxLength={50}
                        onChangeText={setVoucherText}
                        onSubmitEditing={() =>
                            onClose({ sync: true, voucherText })
                        }
                        onClear={() => setVoucherText("")}
                    />
                </InputControl>
                <View style={styles.buttonContainer}>
                    <Button
                        onPress={() => {
                            onClose({ sync: false });
                        }}
                        style={styles.buttonCancel}
                        testID="modal:cancel"
                    >
                        {t("common.cancel", "Cancel")}
                    </Button>
                    <Button
                        type="primary"
                        onPress={() => {
                            onClose({ sync: true, voucherText });
                        }}
                        style={styles.buttonConfirm}
                        testID="modal:confirm"
                    >
                        {t("backoffice.confirm", "Accept")}
                    </Button>
                </View>
            </View>
        </ModalWrapper>
    );
}

const styleFunc: StyleFunction = (theme, dimensions) => {
    let styling: StyleData = {
        container: {
            padding: theme.spacingScale * 2,
            paddingTop: 0,
            minWidth: 250,
            maxWidth:
                dimensions.width <= theme.breakpoint.portraitWidth
                    ? dimensions.width
                    : 480,
        },
        buttonContainer: {
            flexDirection: "row",
            justifyContent: "space-between",
            columnGap: 10,
        },
    };

    if (dimensions.width <= theme.breakpoint.portraitWidth) {
        styling = {
            ...styling,

            container: {
                ...styling.container,
                width: dimensions.width - theme.spacingScale * 2,
                maxWidth: "auto",
            },
        };
    }

    return styling;
};
